import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import ClickEaterFactory from "../../../../core/ui/ClickEaterFactory";
import Graph from "../../../components/graphs/Graph";
import GraphAxesDisplayOptions from "../../../components/graphs/GraphAxesDisplayOptions";
import GraphAxisDisplayOptions from "../../../components/graphs/GraphAxisDisplayOptions";
import GraphAxisIntervalDisplayOptions from "../../../components/graphs/GraphAxisIntervalDisplayOptions";
import GraphAxisLegendDisplayOptions from "../../../components/graphs/GraphAxisLegendDisplayOptions";
import LineGraphDisplayOptions from "../../../components/graphs/LineGraphDisplayOptions";
import Vector2 from "../../../components/graphs/Vector2";
import StoryVariables from "../../../util/StoryVariables";
import DashboardNumberChartFactory from "../../controller/DashboardNumberChartFactory";
import DashboardConfig from "../../model/DashboardConfig";
import DashboardData from "../../model/DashboardData";
import DashboardSingleData from "../../model/DashboardSingeData";
import DashboardTabMediator from "./DashboardTabMediator";

export default class DashboardHealthSystemsTabMediator extends DashboardTabMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LanguagePack} languagePack 
     * @param {DashboardNumberChartFactory} dashboardNumberChartFactory 
     * @param {DashboardConfig} dashboardConfig 
     * @param {DashboardData} dashboardData 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardNumberChartFactory, dashboardConfig, dashboardData, saveGameModel) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
        this._dashboardNumberChartFactory = dashboardNumberChartFactory;
        this._languagePack = languagePack;
        this._dashboardConfig = dashboardConfig;
        this._dashboardData = dashboardData;
        this._saveGameModel = saveGameModel;
        this._numberCharts = [];
    }

    initialize() {
        super.initialize();
        this._localiseTexts();
        this._initializeNumberCharts();
    }

    _localiseTexts() {
        this._target.LabelTab2.text = this._languagePack.getText(`dashboard.healthSystemsTab.legendTab`);
        this._target.FirstCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.firstCategory`);
        this._target.SecondCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.secondCategory`);
        this._target.ThirdCategoryTitleTextField.text = this._languagePack.getText(`dashboard.healthSystemsTab.thirdCategory`);
    }

    _initializeNumberCharts() {
        let dashboardConfigs = this._dashboardConfig.dashboardHealthSystems;
        var self = this;
        dashboardConfigs.forEach(function (dashboardConfig, index) {
            var numberChart = self._dashboardNumberChartFactory.createNumberChart(
                self._target["DataElement" + (index + 1)],
                dashboardConfig,
                DashboardNumberChartFactory.HEALTH_SYSTEMS
            );
            self._numberCharts.push(numberChart);
        });
    }

    destroy() {
        super.destroy();
        for (let i = 0; i < this._numberCharts.length; i++) {
            const numberChart = this._numberCharts[i];
            numberChart.destroy();
        }

        this._numberCharts = [];
        this._target.removeAllChildren();
    }
    get skin() {
        return this._target;
    }
}